import { SupportedLanguage } from './supportedLanguages';

/**
 * Default system language
 */
export const defaultLanguage: SupportedLanguage = 'en-UK';
